import { render, staticRenderFns } from "./CouponActionCell.vue?vue&type=template&id=70ead90e&scoped=true&"
import script from "./CouponActionCell.vue?vue&type=script&lang=babel&"
export * from "./CouponActionCell.vue?vue&type=script&lang=babel&"
import style0 from "./CouponActionCell.vue?vue&type=style&index=0&id=70ead90e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ead90e",
  null
  
)

export default component.exports